/**
 * RSA 加解密工具类
 */
import JSEncrypt from '@/utils/encryption/jsencrypt/lib/index.js';
import { hex2b64 } from '@/utils/encryption/jsencrypt/lib/lib/jsbn/base64.js';
import { hexToBytes, bytesToHex, base64ToArrayBuffer } from '@/utils/encryption/jsencrypt/lib/lib/JSEncryptRSAassist';
/**
 * @FunctionName: 加密
 * @param {*} txt
 * @return {*}
 * @Author: zhuzhaoyang
 * @Date: 2021-10-29 11:07:29
 * @Modification history: 
 * @Description: 
 */
export function encryptRSA(word, pubilcKey) {
  const encrypt = new JSEncrypt();
  encrypt.setPublicKey(pubilcKey || window.RSA_KEY);
  // 加密
  return encrypt.encryptLong2(word);
  // return encrypt.decryptUnicodeLong(word);
}
/**
 * @FunctionName: 解密
 * @param {*} word
 * @param {*} secretKey
 * @return {*}
 * @Author: zhuzhaoyang
 * @Date: 2021-10-29 11:07:40
 * @Modification history: 
 * @Description: 
 */
export function decryptRSA(word, pubilcKey) {
  const decrypt = new JSEncrypt();
  decrypt.setPublicKey(pubilcKey || window.RSA_KEY);
  // 解密数据
  // 后端使用 URLEncoder 进行编码，前端解密后使用 decodeURIComponent 解码解决中文乱码问题
  return decodeURIComponent(decrypt.decryptLong(base64ToArrayBuffer(word)));
  // return decrypt.decryptUnicodeLong(word);
}

/**
 * encrypt long string 加密1
 * @param string
 * @returns {*}
 */
JSEncrypt.prototype.encryptLong = function (string) {
  let k = this.getKey();
  let maxLength = (((k.n.bitLength() + 7) >> 3) - 11);
  try {
    let lt = '';
    let ct = '';
    if (string.length > maxLength) {
      lt = string.match(/.{1,117}/g);
      lt.forEach(function (entry) {
        let t1 = k.encrypt(entry);
        ct += t1;
      });
      return hex2b64(ct);
    }
    let t = k.encrypt(string);
    let y = hex2b64(t);
    return y;
  } catch (ex) {
    console.log('RSA分段加密1', ex);
    return false;
  }
};
/**
 * encrypt long string 加密2
 * @param string
 * @returns {*}
 */
JSEncrypt.prototype.encryptLong2 = function (string) {
  let k = this.getKey();
  try {
    let ct = '';
    //RSA每次加密117bytes，需要辅助方法判断字符串截取位置
    //1.获取字符串截取点
    let bytes = new Array();
    bytes.push(0);
    let byteNo = 0;
    let len, c;
    len = string.length;
    let temp = 0;
    for (let i = 0; i < len; i++) {
      c = string.charCodeAt(i);
      if (c >= 0x010000 && c <= 0x10FFFF) {
        byteNo += 4;
      } else if (c >= 0x000800 && c <= 0x00FFFF) {
        byteNo += 3;
      } else if (c >= 0x000080 && c <= 0x0007FF) {
        byteNo += 2;
      } else {
        byteNo += 1;
      }
      if ((byteNo % 117) >= 114 || (byteNo % 117) == 0) {
        if (byteNo - temp >= 114) {
          bytes.push(i);
          temp = byteNo;
        }
      }
    }
    //2.截取字符串并分段加密
    if (bytes.length > 1) {
      for (let i = 0; i < bytes.length - 1; i++) {
        let str;
        if (i == 0) {
          str = string.substring(0, bytes[i + 1] + 1);
        } else {
          str = string.substring(bytes[i] + 1, bytes[i + 1] + 1);
        }
        let t1 = k.encrypt(str);
        ct += t1;
      }

      if (bytes[bytes.length - 1] != string.length - 1) {
        let lastStr = string.substring(bytes[bytes.length - 1] + 1);
        ct += k.encrypt(lastStr);
      }
      return hex2b64(ct);
    }
    let t = k.encrypt(string);
    let y = hex2b64(t);
    return y;
  } catch (ex) {
    console.log('RSA分段加密2', ex);
    return false;
  }
};
/**
 * 分段解密1
 * @param string
 * @returns {string|boolean}
 */
JSEncrypt.prototype.decryptLong = function (string) {
  let k = this.getKey();
  // 分段解密最大长度限制 字节
  let MAX_DECRYPT_BLOCK = ((k.n.bitLength() + 7) >> 3);
  try {
    let ct = '';
    let t1;
    let bufTmp;
    let hexTmp;
    let str = bytesToHex(string);
    let buf = hexToBytes(str);
    let inputLen = buf.length;

    //开始长度
    let offSet = 0;
    //结束长度
    let endOffSet = MAX_DECRYPT_BLOCK;

    //分段解密
    while (inputLen - offSet > 0) {
      if (inputLen - offSet > MAX_DECRYPT_BLOCK) {
        bufTmp = buf.slice(offSet, endOffSet);
        hexTmp = bytesToHex(bufTmp);
        t1 = k.decrypt(hexTmp);
        ct += t1;
      } else {
        bufTmp = buf.slice(offSet, inputLen);
        hexTmp = bytesToHex(bufTmp);
        t1 = k.decrypt(hexTmp);
        ct += t1;
      }
      offSet += MAX_DECRYPT_BLOCK;
      endOffSet += MAX_DECRYPT_BLOCK;
    }
    return ct;
  } catch (ex) {
    console.log('RSA分段解密失败', ex);
    return false;
  }
};